import { FactorinGridColumn } from './common';


const ITERATIONS_CAP = 10;
const COLUMN_MIN_WIDTH = 10;

export const getColumnMinWidth = ({ fixedWidth, minWidth }: FactorinGridColumn, rem: number) =>
    (fixedWidth || minWidth || COLUMN_MIN_WIDTH) * rem;

export const calculateColumnWidths = (
    containerWidth: number,
    columns: FactorinGridColumn[],
    columnRatios: any,
    rem: number,
): number[] => {
    const realWidths = new Array<number>(columns.length);
    const surplusWidths = new Array<number>(columns.length);
    let leftToDistribute = 0;
    let ratioTotal = 0;
    for (let i = 0; i < columns.length; i++) {
        const columnRatio = columnRatios[columns[i].field];
        const desiredWidth = (containerWidth - 1) * columnRatio;
        const minWidth = getColumnMinWidth(columns[i], rem);
        const surplus = Math.max(0, minWidth - desiredWidth);
        if (!surplus)
            ratioTotal += columnRatio;
        realWidths[i] = Math.max(minWidth, desiredWidth);
        surplusWidths[i] = surplus;
        leftToDistribute += surplus;
    }
    let canProceed = true;
    let iterations = 0;
    while (leftToDistribute > 1 && canProceed && iterations++ < ITERATIONS_CAP) {
        canProceed = false;
        let distributed = 0;
        for (let i = 0; i < columns.length; i++) {
            const columnRatio = columnRatios[columns[i].field];
            const width = realWidths[i];
            if (surplusWidths[i])
                continue;

            const minWidth = getColumnMinWidth(columns[i], rem);
            const desiredWidth = width - leftToDistribute * columnRatio / ratioTotal;
            const surplus = Math.max(0, minWidth - desiredWidth);
            if (surplus)
                ratioTotal -= columnRatio;
            realWidths[i] = Math.max(minWidth, desiredWidth);
            surplusWidths[i] = surplus;
            distributed += width - realWidths[i];
            canProceed = true;
        }
        leftToDistribute -= distributed;
    }
    return realWidths;
};
